<template>
  <div class="home-res-not-found">
    <div class="nostr-img-cls">
      <img src="@/assets/images/no_store.png" />
      <div class="no-txt-fnd">
        We are currently not serviceable in your area"
      </div>
      <span
        >You can pick your order up from nearest restaurant in the pickup
        section</span
      >
    </div>
  </div>
</template>
  
<script>
export default {
  name: "SystemMessage",
};
</script>